// extracted by mini-css-extract-plugin
module.exports = {"title":"w_p","cards":"w_G"};